<template>
    <div
        class="dropdown is-right action pointer"
        :class="{'is-active': show_dropdown}"
        @mouseleave="show_dropdown = false">

        <div @click="open" class="dropdown-trigger">
            <slot></slot>
        </div>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <div class="dropdown-item">
                    <base-input
                        v-model="search_query"
                        :loading="participants.loading"
                        @input="search"
                        name="search"
                        icon="fas fa-search"
                        placeholder="Search Tags..."
                        autocomplete="off" ref="search_form"/>
                </div>

                <hr class="dropdown-divider"/>

                <a v-for="participant in participants.data.results"
                   :key="participant.id"
                   @click="select(participant)"
                   class="dropdown-item">

                    <avatar :user="participant" class="is-16x16 is-pulled-left"/> &nbsp;
                    {{participant.first_name}} {{participant.last_name}}
                </a>

                <div v-if="not_found" class="dropdown-item">
                    <p>No found</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import Avatar from '../common/Avatar.vue';

export default {
    components: { Avatar },
    props: ['space', 'exclude'],
    computed: {
        ...mapState('spaces', ['participants']),
        not_found() {
            return this.participants.data.results && !this.participants.data.results.length;
        },
    },
    data() {
        return { search_query: '', show_dropdown: false };
    },
    methods: {
        search: debounce(function (search) {
            this.load(search);
        }, 500),
        open() {
            this.show_dropdown = true;
            this.load();
        },
        load() {
            this.$store.dispatch('spaces/participants', {
                space_id: this.space.id,
                search: this.search_query,
                exclude_ids: this.exclude || [],
            });
        },
        select(participant) {
            this.show_dropdown = false;
            this.$emit('select', participant);
        },
    },
};
</script>
